import { API } from '.';
import { handleResponse } from '../helpers';
import { API_URL } from '../config/appConfig';

const getClientBasicInfo = (clientId, tenantId) => {
  const headers = {
    skipJsonContentType: true,
  };
  if (tenantId) {
    headers.tenantId = String(tenantId).trim();
  }

  return API.get(
    `${API_URL.idpAuth}/client/${encodeURIComponent(clientId)}/basic`,
    "client_info",
    {},
    {},
    { headers }
  ).then((res) => handleResponse(res, true));
};

export const clientService = {
  getClientBasicInfo
};
